export default "__VITE_ASSET__BGdf6xBJ__"